/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.16.0
 * @since 1.16.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../theme';

export const PersonalDataConfirmModalStyled = styled.div.attrs({
    className: 'personal-data-confirm-modal',
})`
    .confirm-modal__error {
        display: flex;
        flex-direction: column;
        align-items: center;

        ${fonts.textHeader3};
        color: ${colors.textColorDanger};
        margin-bottom: 16px;

        .confirm-modal__error-img {
            border: 1px solid ${colors.borderColorDisabled};
            border-radius: 100%;
            margin-bottom: 24px;
        }
    }

    .confirm-modal__text {
        margin-bottom: 24px;
    }

    .confirm-modal__subtitle {
        ${fonts.textMainBold};
        margin-bottom: 16px;
        text-align: center;
    }

    .confirm-modal__step-list {
        .confirm-modal__step:not(:last-child) {
            margin-bottom: 16px;
        }
    }

    .confirm-modal__step {
        display: grid;
        grid-template-columns: auto 1fr;
        grid-column-gap: 16px;

        background-color: ${colors.backgroundColorModal};
        padding: 16px 24px;

        .confirm-modal__step-count {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 32px;
            height: 32px;
            background-color: ${colors.backgroundColorDisabledDark};
            border-radius: 32px;
            ${fonts.textMainBold};
        }
    }
`;
